module.exports = __webpack_public_path__ + "f486266d034f1e69b98d4e35cc6615c2.svg";